import { Block, PathUtils } from 'slate';
import BlockTypes from '../../../types/BlockTypes';
export default function focusFirstLine(editor) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$insertLine = _ref.insertLine,
      insertLine = _ref$insertLine === void 0 ? false : _ref$insertLine;

  var nodes = editor.value.document.nodes;
  var firstNode = nodes.first();

  if (nodes.size === 1 && firstNode.type === BlockTypes.UNSTYLED && firstNode.text === '') {
    // We skip only if the document contains 1 empty unstyled, the
    // default empty state.
    return editor.focus();
  }

  var path = PathUtils.create([]);

  if (insertLine) {
    editor.insertNodeByPath(path, 0, Block.create(BlockTypes.UNSTYLED));
  }

  var firstText = editor.value.document.getFirstText();

  if (firstText) {
    return editor.moveTo(firstText.key, offset).focus();
  }

  return editor.moveToStartOfDocument().focus();
}